import type { ReactElement } from 'react';
import logo from './assets/logo.svg';

/** The bettercoach mark: a lattice of rounded crosses. */
const MARK_PATH =
  'M 48 28.667 L 48 19.333 C 48 17.5 46.5 16 44.667 16 L 35.333 16 C 33.5 16 32 17.5 32 19.333 L 32 28.667 C 32 30.5 30.5 32 28.667 32 L 19.333 32 C 17.5 32 16 33.5 16 35.333 L 16 44.667 C 16 46.5 17.5 48 19.333 48 L 28.667 48 C 30.5 48 32 49.5 32 51.333 L 32 60.667 C 32 62.5 33.5 64 35.333 64 L 44.667 64 C 46.5 64 48 62.5 48 60.667 L 48 51.333 C 48 49.5 49.5 48 51.333 48 L 60.667 48 C 62.5 48 64 49.5 64 51.333 L 64 60.667 C 64 62.5 62.5 64 60.667 64 L 51.333 64 C 49.5 64 48 65.5 48 67.333 L 48 76.667 C 48 78.5 46.5 80 44.667 80 L 35.333 80 C 33.5 80 32 78.5 32 76.667 L 32 67.333 C 32 65.5 30.5 64 28.667 64 L 19.333 64 C 17.5 64 16 62.5 16 60.667 L 16 51.333 C 16 49.5 14.5 48 12.667 48 L 3.333 48 C 1.5 48 0 46.5 0 44.667 L 0 35.333 C 0 33.5 1.5 32 3.333 32 L 12.667 32 C 14.5 32 16 30.5 16 28.667 L 16 19.333 C 16 17.5 17.5 16 19.333 16 L 28.667 16 C 30.5 16 32 14.5 32 12.667 L 32 3.333 C 32 1.5 33.5 0 35.333 0 L 44.667 0 C 46.5 0 48 1.5 48 3.333 L 48 12.667 C 48 14.5 49.5 16 51.333 16 L 60.667 16 C 62.5 16 64 17.5 64 19.333 L 64 28.667 C 64 30.5 62.5 32 60.667 32 L 51.333 32 C 49.5 32 48 30.5 48 28.667 Z';

export function BrandLockup({ height = 24 }: { height?: number }): ReactElement {
  return (
    <img
      src={logo}
      alt="bettercoach"
      style={{ height, width: 'auto' }}
      className="block self-start"
    />
  );
}

/**
 * The oversized outlined mark behind the sign-in panel.
 *
 * A stroked copy of the logo rather than an image, so it inherits the palette and stays
 * crisp at any size. The viewBox is padded so the outline never clips against the panel
 * edge, and `meet` keeps the whole lattice readable instead of cropping into one corner.
 */
export function BrandBackdrop(): ReactElement {
  return (
    <svg
      className="absolute inset-0 size-full"
      viewBox="-6 -6 76 92"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
    >
      <path d={MARK_PATH} stroke="rgba(10,56,51,.18)" strokeWidth="0.5" fill="none" />
    </svg>
  );
}
